import React, { Component } from "react"
import { graphql } from "gatsby"
import { MDXProvider } from "@mdx-js/react"
import { MDXRenderer } from "gatsby-plugin-mdx"
import CodeBlock from "@components/codeblock"
import ColourBlock from "@components/colourBlock"
import UsageBlock from '@components/usageblock'
import Layout from "@components/layout"
import Masthead from "@components/masthead"
import UsageImage from '@components/usageimage'
import ComponentItem from '@components/componentitem'
const components = {
  pre: props => <div {...props} />,
  code: CodeBlock,
  Masthead,
  UsageBlock,
  ColourBlock,
  UsageImage,
  ComponentItem,
  h1: props => (<h1 id={props.children.replace(/\s+/g, '').toLowerCase()} {...props} />),
  h2: props => (<h2 id={props.children.replace(/\s+/g, '').toLowerCase()} {...props} />),
  h3: props => (<h3 id={props.children.replace(/\s+/g, '').toLowerCase()} {...props} />),
}

export default class MDXRuntimeTest extends Component {
  render() {
    const { children, data} = this.props
    return (
      <MDXProvider components={{...components}}>
        <Layout title={data.mdx.frontmatter.title}>
          <div className="docMain">
            {children}
          <MDXRenderer>{data.mdx.body}</MDXRenderer>
          </div>
        </Layout>
      </MDXProvider>
    )
  }
}

export const pageQuery = graphql`
  query($id: String!) {
    mdx(id: { eq: $id }) {
      id
      body
      frontmatter {
        title
      }
    }
  }
`
